import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import { ToastContainer, toast } from "react-toastify";
import CountUp from "react-countup";
import { connect } from "react-redux";
import { DollarSign } from "react-feather";
import {
  getAllPartialsRedux,
  uploadPartialRedux,
  updatePartialRedux,
  deletePartialRedux,
} from "../../../actions";
import {
  uploadImageRechargeRequest,
  getFreeShipping,
  uploadfreeShipping,
  get1688PaymentsByDateRange,
  getSinglePayment1688,
  updatepaymentLink1688,
  updatepaymentLink,
} from "../../../firebase/firebase.utils";
import man from "./plus image.jpeg";
import { Search } from "react-feather";
import { generate1688PaymentLink } from "../../../actions/get1688Data";
export class PartialPayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      name: "",
      expirationDate: "",
      payNow100: "",
      payNow80: "",
      payNow60: "",
      searchFor: "",
      day: "",
      week: "",
      month: "",
      year: "",
      customStart: "",
      customEnd: "",
      linkStatus: "",
      rmbStatus: "",
      data: [],
      imageUrl: man,
      loading: false,
    };
  }

  componentDidMount() {
    const today = new Date();
    const past = new Date();
    past.setDate(today.getDate() - 30);

    // Format: YYYY-MM-DD (consistent everywhere)
    const endDate = today.toISOString().split("T")[0];
    const startDate = past.toISOString().split("T")[0];
    this.setState({
      customStart: startDate,
      customEnd: endDate,
    });
    this.loadLast30Days(startDate, endDate);
  }

  loadLast30Days = async (startDate, endDate) => {
    const data = await get1688PaymentsByDateRange(startDate, endDate);
    console.log("Last 30 days data:", data);

    this.setState({ data: data });
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleTypeChange = (e) => {
    this.setState({ type: e.target.value });
  };

  applyRange = async () => {
    const { type, customStart, customEnd, linkStatus, rmbStatus } = this.state;
    console.log(customStart);
    console.log(customEnd);
    if (customStart && customEnd) {
      let data = await get1688PaymentsByDateRange(
        customStart,
        customEnd,
        linkStatus,
        rmbStatus
      );
      this.setState({
        data: data,
      });
    }
  };

  handleSearchBarChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  _handleImgChange = async (e, i) => {
    e.preventDefault();
    const { currentAdmin } = this.props;

    let reader = new FileReader();
    let file = e.target.files[0];
    const { imageUrl } = this.state;

    reader.onloadend = () => {
      // imageUrl = reader.result;
      this.setState({
        file: file,
        imageUrl,
      });
    };
    if (file) {
      this.setState({ loading: true });
      reader.readAsDataURL(file);
      const imgUrl = await uploadImageRechargeRequest(file);
      console.log(imgUrl);

      this.setState({
        imageUrl: imgUrl,
      });
      console.log(imageUrl);
      this.setState({ loading: false });
    }
  };
  _handleImgChange2 = async (e, i) => {
    e.preventDefault();
    const { currentAdmin } = this.props;

    let reader = new FileReader();
    let file = e.target.files[0];
    const { imageUrl2 } = this.state;

    reader.onloadend = () => {
      // imageUrl = reader.result;
      this.setState({
        file: file,
        imageUrl2,
      });
    };
    if (file) {
      this.setState({ loading2: true });
      reader.readAsDataURL(file);
      const imgUrl = await uploadImageRechargeRequest(file);
      console.log(imgUrl);

      this.setState({
        imageUrl2: imgUrl,
      });
      this.setState({ loading2: false });
    }
  };

  getMonthName = () => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const d = new Date();
    return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
  };

  handleSubmit = async () => {
    if (this.state.partial && this.state.rmbRate && this.state.totalRmb) {
      let updatedPaymenObj = await updatepaymentLink1688(
        this.state.partial,
        this.state.rmbRate,
        this.state.totalRmb,
        this.state.imageUrl
      );
      this.setState({
        data: updatedPaymenObj
          ? this.state.data.map((paymentObj) => {
              if (paymentObj.paymentId == updatedPaymenObj.paymentId) {
                return {
                  ...updatedPaymenObj,
                  rmbRate: this.state.rmbRate,
                  rmbStatus: "Paid",
                };
              } else {
                return paymentObj;
              }
            })
          : this.state.data,
      });
    } else {
      alert("Please fill the missing data.");
    }

    this.setState({
      searchFor: "",
    });
  };
  handleSubmit2 = async (e) => {
    e.preventDefault();
    if (!this.state.searchFor) {
      alert("Payment Id cant be empty.");
      return;
    }
    let paymentObj1688 = await getSinglePayment1688(this.state.searchFor);
    if (paymentObj1688) {
      this.setState({
        paymentObj1688,
      });
    } else {
      alert("Sorry no payment is found with this payment Id");
    }
    console.log("handle submit 2 is getting called!");
  };

  render() {
    const { open, productObj } = this.state;
    const { partials, currentAdmin } = this.props;
    const { customStart, customEnd, data, paymentObj1688 } = this.state;
    let renderablePartials = data;

    if (paymentObj1688) {
      renderablePartials = [paymentObj1688];
    }

    renderablePartials = renderablePartials.sort(
      (a, b) => parseInt(b.paymentId) - parseInt(a.paymentId)
    );
    let totalRmb = 0;
    let totalRmbPaid = 0;
    renderablePartials.map((payment) => {
      totalRmb += parseFloat(payment.totalRmb);
      if (payment.totalRmbPaid) {
        totalRmbPaid += parseFloat(payment.totalRmbPaid);
      }
    });
    console.log(renderablePartials);
    return (
      <Fragment>
        <Breadcrumb title={"1688 Payment Link"} parent="1688-orders" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid">
          <div className="row" style={{ justifyContent: "center" }}>
            <div className="col-sm-12">
              <div className="card">
                <div
                  className="card-header"
                  style={{
                    borderBottom: "1px solid gainsboro",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <h5>
                      <i
                        className="icofont-layout"
                        style={{
                          fontSize: "130%",
                          marginRight: "5px",
                          color: "#00254c",
                        }}
                      ></i>
                      1688 Payment Link <br />
                    </h5>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 10,
                      marginTop: 10,
                    }}
                  >
                    {/* CUSTOM RANGE */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", gap: 10 }}>
                        <input
                          type="date"
                          className="form-control"
                          name="customStart"
                          value={customStart}
                          onChange={this.handleChange}
                        />
                        <input
                          type="date"
                          className="form-control"
                          name="customEnd"
                          value={customEnd}
                          onChange={this.handleChange}
                          min={customStart}
                        />
                        <select
                          title=""
                          name="linkStatus"
                          className="custom-select"
                          aria-required="true"
                          aria-invalid="false"
                          onChange={this.handleChange}
                          value={this.state.linkStatus}
                          style={{ fontSize: ".8rem" }}
                        >
                          <option value="">Link Status</option>
                          <option value="Paid">Paid</option>
                          <option value="Not Paid">Not Paid</option>
                        </select>
                        <select
                          title=""
                          name="rmbStatus"
                          className="custom-select"
                          aria-required="true"
                          aria-invalid="false"
                          onChange={this.handleChange}
                          value={this.state.rmbStatus}
                          style={{ fontSize: ".8rem" }}
                        >
                          <option value="">RMB Status</option>
                          <option value="Paid">Paid</option>
                          <option value="Not Paid">Not Paid</option>
                        </select>
                        <button
                          onClick={this.applyRange}
                          className="btn"
                          style={{ background: "black", color: "white" }}
                        >
                          Apply
                        </button>
                      </div>
                      <li
                        style={{
                          border: "1px solid gainsboro",
                          borderRadius: "5rem",
                          padding: "0px 20px",
                          background: "whitesmoke",
                          marginRight: "20px",
                        }}
                      >
                        <form
                          className="form-inline search-form"
                          onSubmit={this.handleSubmit2}
                        >
                          <div
                            // className="form-group"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-around",
                            }}
                          >
                            <input
                              className={
                                "form-control-plaintext " +
                                (this.state.searchbar ? "open" : "")
                              }
                              name="searchFor"
                              value={this.state.searchFor}
                              type="search"
                              placeholder="Search Payment ID"
                              style={{ paddingLeft: 10 }}
                              onChange={this.handleSearchBarChange}
                            />
                            <span>
                              <Search
                                style={{
                                  marginTop: "5px",
                                  borderLeft: "1px solid gainsboro",
                                  paddingLeft: "7px",
                                  color: "gray",
                                }}
                                onClick={(e) => {
                                  this.handleSubmit2(e);
                                }}
                              />
                            </span>
                          </div>
                        </form>
                      </li>
                    </div>

                    {/* APPLY BUTTON */}
                  </div>
                </div>

                <div className="card-body">
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        gap: 10,
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "bold",
                          fontSize: 17,
                          marginBottom: 5,
                          color: "white",
                          background: "cadetblue",
                          borderRadius: 5,
                          border: "2px solid gainsboro",
                          display: "inline-block",
                          padding: "2px 5px",
                        }}
                      >
                        Total Rmb: ¥ {parseFloat(totalRmb).toFixed(2)}
                      </div>
                      <div
                        style={{
                          fontWeight: "bold",
                          fontSize: 17,
                          marginBottom: 5,
                          color: "white",
                          background: "green",
                          borderRadius: 5,
                          border: "2px solid gainsboro",
                          display: "inline-block",
                          padding: "2px 5px",
                        }}
                      >
                        Total Rmb Paid: ¥ {parseFloat(totalRmbPaid).toFixed(2)}
                      </div>
                    </div>

                    <table className="table table-bordered table-striped table-hover">
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "#00254c",
                              maxWidth: "150px",
                              minWidth: "150px",
                            }}
                          >
                            Date
                          </th>
                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "#00254c",
                              maxWidth: "150px",
                              minWidth: "150px",
                            }}
                          >
                            Payment ID
                          </th>
                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "#00254c",
                              maxWidth: "150px",
                              minWidth: "150px",
                            }}
                          >
                            Payment Link
                          </th>
                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "#00254c",
                              maxWidth: "150px",
                              minWidth: "150px",
                            }}
                          >
                            Total Amount
                          </th>
                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "#00254c",
                              maxWidth: "150px",
                              minWidth: "150px",
                            }}
                          >
                            Link Paid
                          </th>

                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "#00254c",
                            }}
                          >
                            RMB Paid
                          </th>

                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "#00254c",
                            }}
                          >
                            Orders
                          </th>
                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "#00254c",
                            }}
                          >
                            Payment Receipt
                          </th>
                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "#00254c",
                            }}
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {renderablePartials.map((partial, index) => (
                          <tr key={index}>
                            <td style={{ fontWeight: "bold" }}>
                              {partial.date}
                            </td>
                            <td>{partial.paymentId}</td>
                            <td>
                              <div>{partial.paymentLink}</div> <br />
                              {partial.rmbStatus !== "Paid" && (
                                <div
                                  style={{
                                    padding: "2px 5px",
                                    borderRadius: 5,
                                    color: "white",
                                    fontSize: 11,
                                    fontWeight: "bold",
                                    background: "darkorange",
                                    display: "inline-block",
                                    cursor: "pointer",
                                  }}
                                  data-toggle="modal"
                                  data-target="#request_payment"
                                  onClick={() => {
                                    this.setState({
                                      partial: partial,
                                    });
                                  }}
                                >
                                  Regenerate
                                </div>
                              )}{" "}
                            </td>
                            <td
                              style={{
                                verticalAlign: "top",
                                textAlign: "left",
                              }}
                            >
                              <div>
                                <div
                                  style={{
                                    color: "black",
                                    fontWeight: "bold",
                                  }}
                                >
                                  BDT:
                                  {partial.totalRmbPaid * partial.rmbRate
                                    ? `Tk ${parseInt(
                                        partial.totalRmbPaid * partial.rmbRate
                                      )}`
                                    : ""}
                                </div>
                                <div
                                  style={{
                                    fontSize: 13,
                                    color: "#555",
                                    marginTop: 5,
                                  }}
                                >
                                  Rmb: ¥{partial.totalRmb}
                                </div>
                                <div
                                  style={{
                                    fontSize: 13,
                                    color: "#555",
                                    marginTop: 5,
                                  }}
                                >
                                  Rmb(paid): ¥{partial.totalRmbPaid}
                                </div>
                                <div
                                  style={{
                                    fontSize: 13,
                                    color: "#555",
                                    marginTop: 5,
                                  }}
                                >
                                  Rmb Rate:{" "}
                                  {partial.rmbRate ? `¥${partial.rmbRate}` : ""}
                                </div>
                              </div>
                            </td>
                            <td>
                              <span
                                style={{
                                  padding: "1px 5px",
                                  borderRadius: 5,
                                  color: "white",
                                  fontSize: 11,
                                  fontWeight: "bold",
                                  background:
                                    partial.linkStatus == "Not Paid"
                                      ? "red"
                                      : "green",
                                }}
                              >
                                {partial.linkStatus}
                              </span>
                            </td>
                            <td>
                              {" "}
                              <span
                                style={{
                                  padding: "1px 5px",
                                  borderRadius: 5,
                                  color: "white",
                                  fontSize: 11,
                                  fontWeight: "bold",
                                  background:
                                    partial.rmbStatus == "Not Paid"
                                      ? "red"
                                      : "green",
                                }}
                              >
                                {partial.rmbStatus}
                              </span>
                            </td>
                            <td>
                              {" "}
                              <span
                                style={{
                                  padding: "5px 5px",
                                  borderRadius: 5,
                                  color: "white",
                                  fontSize: 15,
                                  fontWeight: "bold",
                                  background: "cadetblue",
                                  cursor: "pointer",
                                }}
                                data-toggle="modal"
                                data-target="#orderData"
                                onClick={() => {
                                  this.setState({
                                    paymentObj: partial,
                                  });
                                }}
                              >
                                see
                              </span>
                            </td>
                            <td>
                              <a href={partial.receipt} target="_blank">
                                <img
                                  style={{ height: 100, width: 150 }}
                                  src={partial.receipt || this.state.imageUrl}
                                />
                              </a>
                            </td>

                            <td>
                              <div
                                className="row"
                                style={{ justifyContent: "center" }}
                              >
                                {partial.rmbStatus !== "Paid" && (
                                  <i
                                    className="icofont-edit"
                                    data-toggle="modal"
                                    data-target="#personalInfoModal"
                                    onClick={() => {
                                      this.setState({
                                        rmbRate: partial.rmbRate
                                          ? partial.rmbRate
                                          : "",
                                        totalRmb: partial.totalRmbPaid
                                          ? partial.totalRmbPaid
                                          : "",
                                        imageUrl: partial.receipt
                                          ? partial.receipt
                                          : man,
                                        partial: partial,
                                        searchFor: "",
                                      });
                                    }}
                                    style={{
                                      color: "green",
                                      marginRight: 8,
                                      cursor: "pointer",
                                    }}
                                  />
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
        <div
          className="modal fade"
          id="orderData"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto", minWidth: "60%" }}
          >
            <div className="modal-content" style={{ top: 10, margin: "auto" }}>
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(0, 37, 76)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Order Summary
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              {this.state.paymentObj &&
                this.state.paymentObj.orders.length > 0 && (
                  <div className="modal-body">
                    <div className="row" style={{ padding: 20 }}>
                      <table className="table table-bordered table-striped table-hover">
                        <thead
                          style={{ background: "#18768f", color: "white" }}
                        >
                          <tr>
                            <td style={{ fontWeight: "bold" }}>Product</td>
                            <td style={{ fontWeight: "bold" }}>Name</td>
                            <td style={{ fontWeight: "bold" }}>Order Number</td>

                            <td style={{ fontWeight: "bold" }}>Total</td>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.paymentObj.orders.map((order) => (
                            <tr>
                              <td>
                                <img
                                  src={order.items[0].picture}
                                  style={{
                                    height: 70,
                                    width: 70,
                                    borderRadius: 5,
                                  }}
                                />
                              </td>
                              <td>{order.items[0].name.slice(0, 100)}</td>
                              <td>{order.orderNumber}</td>
                              <td>
                                <div>
                                  ¥
                                  {order.creationTime1688
                                    ? order.creationTime1688.totalSuccessAmount
                                    : 0}
                                </div>
                                <div style={{ fontSize: 12, color: "#777" }}>
                                  Post fee: ¥
                                  {order.creationTime1688 &&
                                  order.creationTime1688.postFee
                                    ? order.creationTime1688.postFee
                                    : 0}
                                </div>
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <td></td>
                            <td></td>
                            <td>Total</td>
                            <td>
                              ¥
                              {(this.state.paymentObj &&
                                this.state.paymentObj.totalRmb) ||
                                0}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="personalInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div
              className="modal-content"
              style={{ top: 10, width: "95%", margin: "auto" }}
            >
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(0, 37, 76)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Make new payment <br />
                  Payment Id: {this.state.partial?.paymentId}
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              <div className="modal-body" style={{ paddingTop: 5 }}>
                <div style={{ padding: "10px 15px", paddingTop: 0 }}>
                  <div
                    style={{ color: "gray", fontSize: 13, marginBottom: 10 }}
                  >
                    বিশেষ দ্রষ্টব্য:পেমেন্ট Amount আপনার দৈনিক ক্যাশ ব্যালেন্স
                    থেকে বিয়োগ হবে।
                  </div>

                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Total RMB (in receipt)
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="totalRmb"
                      value={this.state.totalRmb}
                      onChange={this.handleChange}
                      id="exampleFormControlInput1"
                      placeholder="Enter Rmb Rate"
                      style={{
                        borderColor: "gainsboro",
                        borderRadius: 5,
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Rmb Rate
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="rmbRate"
                      value={this.state.rmbRate}
                      onChange={this.handleChange}
                      id="exampleFormControlInput1"
                      placeholder="Enter Rmb Rate"
                      style={{
                        borderColor: "gainsboro",
                        borderRadius: 5,
                      }}
                    />
                  </div>
                  <div className="form-group mb-4">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Payment Receipt
                    </label>
                    <div
                      className="box-input-file"
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      {this.state.loading ? (
                        <div
                          className="spinner-border text-light mt-3 ml-2"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        <>
                          <img
                            className="img-100 lazyloaded blur-up"
                            src={this.state.imageUrl}
                            alt="#"
                            style={{
                              zIndex: 10,
                              cursor: "pointer",
                              border: "1px solid gainsboro",
                              borderRadius: 5,
                              minHeight: 100,
                              maxHeight: 100,
                              minWidth: 150,
                              maxWidth: 150,
                            }}
                            onClick={() => {
                              document
                                .getElementById("upload-image-input")
                                .click();
                            }}
                          />

                          <input
                            id="upload-image-input"
                            className="upload"
                            type="file"
                            style={{
                              position: "absolute",
                              zIndex: 5,
                              maxWidth: "50px",
                              marginTop: "20px",
                            }}
                            onChange={(e) => this._handleImgChange(e, 0)}
                          />
                        </>
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <div style={{ fontSize: 14 }}>
                      Total Rmb:
                      {this.state.totalRmb ? `¥ ${this.state.totalRmb}` : ""}
                    </div>
                    <div style={{ marginTop: 5, fontSize: 14 }}>
                      Rmb Rate:{" "}
                      {this.state.rmbRate ? `Tk ${this.state.rmbRate}` : ""}
                    </div>
                    <div
                      style={{ marginTop: 5, fontSize: 22, fontWeight: "bold" }}
                    >
                      Total BDT: Tk
                      {this.state.rmbRate * this.state.totalRmb
                        ? parseInt(this.state.rmbRate * this.state.totalRmb)
                        : 0}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn "
                  data-dismiss={"modal"}
                  style={{
                    backgroundColor: "darkorange",
                    color: "white",
                    padding: 8,
                    borderRadius: 5,
                    fontWeight: "lighter",
                  }}
                  onClick={() => {
                    if (this.state.loading) {
                      alert("Wait your image is being uploaded");
                      return;
                    }
                    if (
                      this.state.imageUrl ==
                      "/static/media/plus image.3dff302b.jpeg"
                    ) {
                      alert("Please upload payment receipt");
                      return;
                    }
                    if (this.state.rmbRate && this.state.totalRmb) {
                      this.handleSubmit();
                    } else {
                      alert("Please enter all missing information");
                    }
                  }}
                >
                  Cash Out
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="request_payment"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto", minWidth: "60%" }}
          >
            <div className="modal-content" style={{ top: 10, margin: "auto" }}>
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(0, 37, 76)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Request for Payment
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              {this.state.partial?.orders &&
                this.state.partial?.orders.length > 0 && (
                  <div className="modal-body">
                    <div className="row" style={{ padding: 20 }}>
                      <table className="table table-bordered table-striped table-hover">
                        <thead
                          style={{ background: "#18768f", color: "white" }}
                        >
                          <tr>
                            <td style={{ fontWeight: "bold" }}>Product</td>
                            <td style={{ fontWeight: "bold" }}>Name</td>
                            <td style={{ fontWeight: "bold" }}>Order Number</td>

                            <td style={{ fontWeight: "bold" }}>Total</td>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.partial?.orders.map((order) => (
                            <tr>
                              <td>
                                <img
                                  src={order.items[0].picture}
                                  style={{
                                    height: 70,
                                    width: 70,
                                    borderRadius: 5,
                                  }}
                                />
                              </td>
                              <td>{order.items[0].name.slice(0, 100)}</td>
                              <td>{order.orderNumber}</td>
                              <td>
                                <div>
                                  ¥
                                  {order.creationTime1688
                                    ? order.creationTime1688.totalSuccessAmount
                                    : 0}
                                </div>
                                <div style={{ fontSize: 12, color: "#777" }}>
                                  Post fee: ¥
                                  {order.creationTime1688 &&
                                  order.creationTime1688.postFee
                                    ? order.creationTime1688.postFee
                                    : 0}
                                </div>
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <td></td>
                            <td></td>
                            <td>Total</td>
                            <td>¥{this.state.partial?.totalRmb || 0}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {this.state.link && (
                      <div>
                        Payment Link:{" "}
                        <a href={this.state.link} target="_blank">
                          {this.state.link}
                        </a>
                      </div>
                    )}
                  </div>
                )}

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
                {this.state.link ? (
                  <button
                    type="button"
                    className="btn "
                    data-dismiss="modal"
                    style={{ background: "green", color: "white" }}
                  >
                    Link Generated!
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn "
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      cursor: "pointer",
                    }}
                    // data-dismiss="modal"
                    onClick={async () => {
                      const orderIdList = this.state.partial.orders.map(
                        (order) => {
                          return order.orderNumber;
                        }
                      );
                      console.log(orderIdList);
                      let link = await generate1688PaymentLink(orderIdList);
                      if (!link) {
                        alert("Link generation failed!");
                        return;
                      }
                      // here create a document inside paymentLinks1688 and update all the orders with paymentLink1688 field
                      await updatepaymentLink({
                        ...this.state.partial,
                        paymentLink: link,
                      });

                      this.setState({
                        link: link,
                        data: link
                          ? this.state.data.map((paymentObj) => {
                              if (
                                paymentObj.paymentId ==
                                this.state.partial.paymentId
                              ) {
                                return {
                                  ...this.state.partial,
                                  paymentLink: link,
                                };
                              } else {
                                return paymentObj;
                              }
                            })
                          : this.state.data,
                      });
                    }}
                  >
                    Regenerate Link
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="deleteExpenseModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div
              className="modal-content"
              style={{ top: 10, margin: "auto", minWidth: "140%" }}
            >
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(0, 37, 76)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Delete Configuration
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              <div className="modal-body">
                <div style={{ padding: "10px 15px" }}>
                  <div>
                    Are you sure you want to delete this partial payments
                    configuration?
                  </div>
                </div>
                <table className="table table-bordered table-striped table-hover">
                  <thead>
                    <tr></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{productObj && productObj.name}</td>
                      <td>{productObj && productObj.discountType}</td>

                      <td>{productObj && productObj.expirationDate}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.setState({
                      productObj: null,
                    });
                  }}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn "
                  data-dismiss="modal"
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    padding: 8,
                    borderRadius: 5,
                  }}
                  onClick={() => {
                    this.props.deletePartialRedux(productObj.id);
                    this.setState({
                      selectAll: false,
                    });
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allUsers: state.users.users,
    currentAdmin: state.admins.currentAdmin,
    partials: state.partials.partials,
  };
};

export default connect(mapStateToProps, {
  getAllPartialsRedux,
  uploadPartialRedux,
  updatePartialRedux,
  deletePartialRedux,
})(PartialPayment);
